<template>
	<div class="case-wrapper">
		<h1 class="case-title">
			<i class="material-icons" @click.prevent="$router.go(-1)">
				keyboard_backspace
			</i>

			<span class="text">{{ currentCase.title }}</span>

			<i
				class="material-icons"
				v-if="currentCase.link"
				:title="currentCase.link"
				@click.prevent="redirect(currentCase.link)"
			>
				open_in_new
			</i>
		</h1>
		<p class="case-description">{{ currentCase.text }}</p>

		<img
			class="case-img"
			:src="`../img/portfolio/${currentCase.slug}/main.png`"
			:alt="currentCase.slug"
			ondragstart="return false"
		/>

		<div class="case-block">
			<h2>Project objective</h2>
			<p>{{ currentCase.objective }}</p>
		</div>

		<div class="case-block">
			<h2>Screens</h2>
			<div class="screens">
				<CoolLightBox
					:items="caseImages"
					:index="currentScreen"
					@close="currentScreen = null"
					:useZoomBar="true"
					:fullScreen="true"
				>
				</CoolLightBox>

				<img
					class="case-screen"
					v-for="(image, i) of caseImages"
					:key="i"
					:src="image"
					:alt="`screen_${i}`"
					@click="currentScreen = i"
					ondragstart="return false"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	beforeRouteEnter(to, from, next) {
		next();
		document.querySelector("#app").classList.add("toCase");
	},
	beforeRouteLeave(to, from, next) {
		document.querySelector("#app").classList.remove("toCase");
		document.querySelector("#app").classList.add("fromCase");
		setTimeout(() => {
			document.querySelector("#app").classList.remove("fromCase");
			next();
		}, 280);
	},
	mounted() {
		window.scrollTo(0, 0);
		document.getElementsByTagName("body")[0].classList = this.currentCase.slug;
	},
	destroyed() {
		document.getElementsByTagName("body")[0].removeAttribute("class");
	},
	data() {
		return {
			currentScreen: null
		};
	},
	methods: {
		redirect(link) {
			window.open(link);
		}
	},
	computed: {
		currentCase() {
			const pathSlug = this.$router.currentRoute.params.slug;
			return this.$store.state.cases.find(c => c.slug === pathSlug);
		},
		caseImages() {
			let images = [];

			for (let i = 1; i <= this.currentCase.maxScreens; i++) {
				try {
					images.push(
						require(`../../public/img/portfolio/${this.currentCase.slug}/screen_${i}.png`)
					);
				} catch (e) {
					console.warn(e.message);
				}
			}

			return images;
		}
	}
};
</script>

<style lang="sass">
@import '@/assets/css/smart-grid'
@import '@/assets/css/_vars'
$m: 1.5rem

.case
	&-wrapper
		min-height: 100vh
		padding-bottom: 2rem
	&-title
		display: flex
		align-items: center
		padding-top: $m
		i
			font-size: .75em
			transition: $tr
			cursor: pointer
			&:hover
				transform: scale(1.15)
		.text
			margin: 0 1.25rem 0 1.75rem
	&-block
		margin-top: $m * 2
	&-description
		font-size: 1.25rem
	&-img
		margin-top: $m

.screens
	+row-flex()
	justify-content: space-around
	.case-screen
		+col()
		+size(6)
		+size-lg(12)
		margin-top: $m
		cursor: pointer
		transition: .3s all
		&:hover
			transform: scale(1.025)

@media screen and (max-width: $break_md)
	.case
		&-title
			font-size: 2rem

@media screen and (max-width: $break_xs)
	$m: .5rem

	.block
		margin-top: $m * 2
	.case
		&-description
			font-size: 1rem
		&-img
			margin-top: $m
		&-title
			font-size: 1.5rem
			.text
				margin: 0 1rem
	.screens
		.case-screen
			margin-top: 0
			&:not(:first-child)
				margin-top: $m * 2
</style>
